import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

let blocks = document.querySelectorAll('.service-benefits');

if(blocks.length > 0) {
  blocks.forEach(block => {
    const containers = block.querySelectorAll('.benefits-wrapper');

    const tl = gsap.timeline({
        scrollTrigger: {
          trigger: containers[0],
          start: 'top bottom-=100',
        }
    });

    containers.forEach(container => {
      tl.from(container.querySelectorAll('.item > *'), {
          autoAlpha: 0,
          y: 20,
          duration: 0.5,
          stagger: 0.1,
          ease: 'power2.out'
      });
    });   
  });
}